import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {Input} from "@progress/kendo-react-inputs";
import React, {useState, useMemo} from "react";
import { useSelector, useDispatch } from "react-redux";
import {capitalize} from "../../shared/shared";
import {ACTION_APPEND_TO_TRUST_LIST} from "../../shared/constants";

const TrustNameDialog = (props) => {

    const [trustName, setTrustName] = useState("");

    const dispatch = useDispatch();

    const trustListData = useSelector((state) =>
        state.dataStore.getIn(["trustList"])
    );

    const trustList = useMemo(() => {
        return trustListData.toJS();
    }, [trustListData]);

    const validateNoInstances = (name) => {
        if (name.trim() === "") return false;
        if(trustList.length === 0) return true;
        return !trustList.some(item => item.toLowerCase() === name.toLowerCase());
    }

    const handleChange = (event) => {
        setTrustName(event.target.value);
    }

    const { handleSave, handleLeave, open } = props;

    const saveTrustName = () => {
        if (!validateNoInstances(trustName)) return;

        const name = capitalize(trustName);

        dispatch({
            type: ACTION_APPEND_TO_TRUST_LIST,
            value: trustName
        });

        handleSave(props.dataItem, name);
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogContent style={{ margin: "auto" }}>
                <Input
                    placeholder={"Trust"}
                    maxLength={25}
                    value={trustName}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleLeave}>
                    Cancel
                </Button>
                <Button disabled={!validateNoInstances(trustName)} onClick={saveTrustName}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default TrustNameDialog;
